import Step from './step.element.js';

export default Step;

Step.define('wje-step', Step);
